import axios from '../http'
import global from '@/constants/Global.constants'

export default {
  memberList (params) { // 获取会员列表
    return axios.post(global.MMC_INFO + '/member/findMember', params)
  },
  memberAdd (params) { // 获取会员新增
    return axios.post(global.MMC_INFO + '/memberType/findMemberType', params)
  },
  memberType (params) { // 获取会员类型
    return axios.post(global.MMC_INFO + '/memberType/findMemberType', params)
  },
  newmember (params) { // 获取会员类型
    return axios.post(global.MMC_INFO + '/memberType/insertMemberType', params)
  },
  newmemberType (params) { // 获取新增会员类型
    return axios.post(global.MMC_INFO + '/memberType/findMemberType', params)
  },
  memberLevelType (){ // 获取会员层级
    return axios.post(global.MMC_INFO + '/memberLevel/findMemberLevelList')
  }
}



// WEBPACK FOOTER //
// ./src/request/mcc/designList.js